<template>
  <div class="filelist-header">
    <div class="list-header-middle">
      <!--如果有文件被选中，则显示该项-->
      <div
        v-if="headerInfo.checkbox && selectedLen > 0 && !isDisabled"
        :class="[headerInfo.replaceAllHeaderInfo? 'calc-checked-title-all' : 'calc-checked-title-part']"
      >
        <!--显示选中的文件数量-->
        <span>{{ checkedSummary }}</span>
        <!--外部插槽-->
        <slot name="operate" />
      </div>

      <!--头部信息-->
      <ul
        v-if="listMode"
        class="header-info"
      >
        <li
          v-for="(item, index) in curHeaderInfo"
          :key="index"
          :class="[`head-${index}`,item.class,'file-header-title',item.sort ? 'head-cansort' : 'head-nosort']"
          :style="`${item.style}; width:${listMode && !listDrageStylesResize?listDragStyles.get(index):''}`"
          @click="clickHandler(item, $event)"
        >
          <!--拖动部分-->
          <b
            v-if="item.drag"
            class="cursor-movement"
          >||</b>
          <!--排序部分-->
          <span class="header-title">
            <span class="title-content">{{ $t(item.title) }}</span>
            <i
              v-if="item.sort && item.sortStatus"
              class="icon"
              :class="['', 'i-sort-asc', 'i-sort-desc'][item.sortStatus]"
            />
          </span>
        </li>
      </ul>
    </div>

    <!--左侧选中部分-->
    <div class="list-header-left">
      <span
        v-if="headerInfo.checkbox"
        class="box-checkbox-inner"
        :class="[checkedAll && !isDisabled? 'checkbox-checked': '', isDisabled? 'checkbox-disabled-click':'']"
        @click="toggleSelectAll"
      />
    </div>

    <!--右侧大图模式图标和搜索部分-->
    <div class="list-header-right">
      <!-- 大图模式列表模式切换按钮 -->
      <slot name="operView" />

      <!-- 大图模式下的排序入口 -->
      <el-dropdown
        v-if="isSortEntryShow"
        class="sort-entry"
        placement="bottom"
        trigger="click"
        @command="sortHandler"
      >
        <!-- 气泡提示 -->
        <co-tips
          class="item"
          effect="dark"
          :content="$t('选择排序方式')"
          placement="top"
        >
          <span class="sort-bg other-icon-back" />
        </co-tips>
        <el-dropdown-menu
          slot="dropdown"
          class="hide-sortlist"
          :style="{'min-width': $i18n.locale==='en' ? '154px' : '124px'}"
        >
          <el-dropdown-item
            v-for="item in sortInfo"
            :key="item.name"
            :command="item"
            :class="item.sortStatus!=0? 'sort-active':''"
            style="position:relative"
          >
            <svg
              v-if="item.sortStatus!=0"
              class="gou"
            >
              <use xlink:href="#gou" />
            </svg>
            <span v-if="item.sort">{{ $t(item.sortName) }}</span>
            <i
              v-if="item.sort"
              class="icon-sort"
              :class="['i-sort-none', 'i-sort-asc', 'i-sort-desc'][item.sortStatus]"
            />
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
import coTips from 'components/common/tips/index.vue'

export default {
  components: {
    coTips,
  },
  props: {
    value: '',
    headerInfo: Object, // 头部数据信息
    sortInfo: Array,
    listMode: Boolean, // 预览模式
    listDragStyles: Map, // 存储尺寸的map对象
    listDrageStylesResize: Boolean, // 是否恢复原有尺寸
    haveSort: Boolean, // 显示大图模式的排序
    isDisabled: Boolean, // 禁止鼠标点击checkbox
    selectFile: Object, // 被选中的文件对象
  },
  data() {
    return {
      contentInfo: [],
    }
  },
  computed: {
    // 选中文件的长度
    selectedLen() {
      return this.selectFile.data.length
    },
    // 是否显示全选
    checkedAll() {
      return this.contentInfo.length && this.selectFile.data.length === this.contentInfo.length
    },
    // 获取要显示的头部数据(外联部分返回list,不包含查询)
    infoType() {
      return 'list'
    },
    // 当前显示的头部信息
    curHeaderInfo() {
      return this.headerInfo[this.infoType]
    },
    // 显示选中的项目数量
    checkedSummary() {
      const len = this.selectFile.data.length
      const summary = this.$t('已选中{len}项', { len })
      return summary
    },
    // // 显示大图模式的排序
    isSortEntryShow() {
      return this.haveSort && !this.listMode
    },
  },
  watch: {
    contentInfo(n) {
      this.$emit('input', n)
    },
    value(n) {
      this.contentInfo = n
    },
  },
  created() {
    this.contentInfo = this.value
  },
  mounted() {
    this.$nextTick(() => {
      document.addEventListener('keydown', this.ctrlASelectAll)
    })
  },
  destroyed() {
    this.$nextTick(() => {
      document.removeEventListener('keydown', this.ctrlASelectAll)
    })
  },
  methods: {
    // 点击列表名称
    clickHandler(info, e) {
      const target = e.target || e.srcElement
      // 判断是否点击的是拖动,如果是拖动则不处理
      if (target.className === 'cursor-movement') {
        return
      }
      // 该列支持排序
      if (info.sort) { this.sortHandler(info, e) }
    },
    /**
             * 列表排序功能
             */
    sortHandler(info) {
      const self = this
      // 清空选中的排序
      function clearSelect() {
        self.contentInfo.forEach((data) => {
          // 更新所有选中item的选中属性，设置为false
          self.$set(data, 'checked', false)
        })
        // 清空选中的文件
        self.selectFile.selectedDataClear()
      }
      clearSelect() // 点击排序时清空选中
      // 排序取反
      // info.sortStatus = info.sortStatus === 1 ? 2 : 1
      // 将其他排序设置为0
      this.sortInfo.forEach((item) => {
        if (item.sort && info.name !== item.name) {
          item.sortStatus = 0
        } else {
          item.sortStatus = item.sortStatus === 1 ? 2 : 1
        }
      })
      this.curHeaderInfo.forEach((item) => {
        if (item.sort && info.name !== item.name) {
          item.sortStatus = 0
        } else {
          item.sortStatus = item.sortStatus === 1 ? 2 : 1
        }
      })
      // 设置新的排序方式和规则
      const sortInfo = {
        name: info.name,
        sortStatus: info.sortStatus,
      }
      // 抛出排序事件
      this.$emit('doSort', sortInfo)
    },
    /**
             * 标题部分全选.全部不选操作
             */
    toggleSelectAll() {
      // 创建新的存储对象
      const newContentInfo = [...this.contentInfo]
      if (!this.checkedAll) {
        newContentInfo.forEach((data, index) => {
          data.checked = true
          // 存储选中的数据
          this.selectFile.selectedDataAdd({ index, data })
        })
        // 重新赋值
        this.contentInfo = newContentInfo
      } else {
        newContentInfo.forEach((data, index) => {
          data.checked = false
        })
        // 删除所有选中数据
        this.selectFile.selectedDataClear()
        // 重新赋值
        this.contentInfo = newContentInfo
      }
    },
    /**
             * ctrl+a 选中所有
             */
    ctrlASelectAll(e) {
      // 判断是否有下载的权限
      let downPower = true
      downPower = this.contentInfo['0'] && /download/.test(this.contentInfo['0'].access_mode)
      if (e.ctrlKey && e.keyCode === 65 && downPower) {
        this.toggleSelectAll()
      }
    },
  },
}
</script>

<style lang="less" scoped>
@import '~less/variable.less';
.list-header-middle{
  .calc-checked-title-part{
    color: @lightGray;
    position: absolute;
    line-height: 30px;
    +.header-info{
      .file-header-title:nth-child(1){
        visibility: hidden;
      }
    }
  }
  .calc-checked-title-all{
    position: absolute;
    +.header-info{
      visibility: hidden;
    }
  }
}

//头部样式
.filelist-header {
  padding-left: 35px;
  padding-right: 25px;
  height: 30px;
  border-bottom: 1px solid #eaeaea;
  background: #fff;
  .list-header-left,
  .list-header-right,
  .list-header-middle {
    position: relative;
    float: left;
    height: 30px;
    line-height: 30px;
  }
  //中间部分
  .list-header-middle {
    width: 100%;
    span {
      font-size: 12px;
    }
    .icon {
      line-height: 20px;
      text-align: center;
      margin: 6px 0 0 8px;
    }
    .header-info {
      position: relative;
      width: 100%;
      line-height: 30px;
      li{
        cursor: pointer;
      }
      &::after {
        content: '';
        display: block;
        width: 0px;
        height: 0px;
        visibility: hidden;
        clear: both;
      }
      .file-header-title {
        color: @darkGray;
        float: left;
        height: 30px;
        & .cursor-movement {
          cursor: w-resize;
          margin-right: 5px;
          font-weight: 100;
          color: #c6cdd7;
          float: left;
          font-size: 14px;
        }
        .title-content {
          float: left;
          margin-right: 4px;
        }
        &.name-title {
          width: 60%;
          min-width: 210px;
        }
        &.mtime-update-title {
          width: 28%;
          min-width: 160px;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        &.size-title {
          width: 10%;
          min-width: 60px;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 12px;
        }
        &.head-cansort {
          .header-title{
            cursor: pointer;
            &:hover{
              color: @blackColor;
            }
          }
        }
        &.head-nosort {
          cursor: default;
        }

        //响应式部分代码
        @media only screen and (max-width: 1260px) {
          &.name-title {
            width: 55%;
            min-width: 160px;
          }
          &.mtime-update-title {
            width: 30%;
            min-width: 150px;
          }
          &.size-title {
            width: 10%;
            min-width: 50px;
          }
        }
        @media only screen and (max-width: 1160px) {
          &.name-title {
            width: 50%;
            min-width: 160px;
          }
          &.mtime-update-title {
            width: 32%;
            min-width: 150px;
          }
          &.size-title {
            width: 10%;
            min-width: 60px;
          }
        }
        @media only screen and (max-width: 1080px) {
          &.name-title {
            width: 44%;
            min-width: 160px;
          }
          &.mtime-update-title {
            width: 32%;
            min-width: 150px;
          }
          &.size-title {
            width: 10%;
            min-width: 60px;
          }
        }
      }
    }

  }

  //左侧checkbox部分
  .list-header-left {
    width: 35px;
    margin-left: -100%;
    left: -35px;
    text-indent: 6px;
    line-height: 30px;
    .list-header-checkbox {
      float: left;
      display: block;
      width: 16px;
      height: 16px;
      margin-top: 2px;
      margin-left: 6px;
      cursor: pointer;
    }
  }

  //右侧按钮部分
  .list-header-right {
    width: 50px;
    margin-left: -50px;
    right: -15px;
    line-height: 24px;
    div,span{
      float: right;
      margin-left: 10px;
      margin-top: 2px;
      width: 20px;
      height: 30px;
      cursor: pointer;
    }
    .operView{
      margin-left: 0;
    }
    .sort-entry{
      position:relative;
      right:8px;
      top:-2px;
    }
    .other-icon-back{
      width: 22px;
      height: 22px;
      padding: 2px;
      border-radius: 2px;
      &:hover {
        background-color: #e8ebef;
      }
    }
    @media only screen and (max-width: 1024px){
      .sort-entry{
        display: inline-block;
        right:0px;
      }
      .operView{
        margin-left: 10px;
      }
      &.list-header-right{
        width: 90px;
        margin-left: -90px;
        right: -20px;
      }
    }
  }
}

/*关于排序部分的样式*/
.i-sort-asc {
  display: inline-block;
  background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIxMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGZpbGw9IiM5MjlDQTkiIGQ9Ik0zLjUgMTBMNyA2SDB6Ii8+PHBhdGggZmlsbD0iIzFCMjczMyIgZD0iTTMuNSAwTDcgNEgweiIvPjwvZz48L3N2Zz4=) no-repeat;
}

.i-sort-desc {
  display: inline-block;
  background: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNyIgaGVpZ2h0PSIxMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGZpbGw9IiM5MjlDQTkiIGQ9Ik0zLjUgMEw3IDRIMHoiLz48cGF0aCBmaWxsPSIjMUIyNzMzIiBkPSJNMy41IDEwTDcgNkgweiIvPjwvZz48L3N2Zz4=) no-repeat;
}

.sort-bg {
  display: inline-block;
  background: url(~image/sort-entry.svg) no-repeat;
  background-position:3px 2px;
}

.icon-sort {
  line-height: 20px;
  text-align: center;
  margin: 8px 0 0 8px;
  display: inline-block;
  width: 8px;
  height: 20px;
  vertical-align: middle;
  cursor: pointer;
}

.sort-active {
  background: #f6f7fa;
}

.gou{
  display: block;
  position: absolute;
  width: 12px;
  height: 9px;
  top: 14px;
  left: 8px;
}

.el-dropdown-menu__item{
  padding:0px 28px !important;
}

.el-popper[x-placement^=bottom] {
  margin-top:0px;
}

//checkbox禁止点击
.checkbox-disabled-click {
  pointer-events:none;
  border:1px solid #C1C7CD;
  background-color:#F6F7FA;
}
</style>

<style lang="less">
.el-popper[x-placement^=bottom] .popper__arrow{
  top:0px !important;
  border:none;
}

.el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #F6F7FA !important;
  color: #1B2733 !important;
}

.el-dropdown-menu {
  padding:8px 0px;
}
</style>
